export default {
  SET_LANGUAGE_DATA(state, data) {
    state.language = data;
  },
};
